"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGiveawaySchedulerConfigRequestToJSON = exports.CreateGiveawaySchedulerConfigRequestFromJSONTyped = exports.CreateGiveawaySchedulerConfigRequestFromJSON = exports.instanceOfCreateGiveawaySchedulerConfigRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateGiveawaySchedulerConfigRequest interface.
 */
function instanceOfCreateGiveawaySchedulerConfigRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "durationTime" in value;
    isInstance = isInstance && "ownerId" in value;
    return isInstance;
}
exports.instanceOfCreateGiveawaySchedulerConfigRequest = instanceOfCreateGiveawaySchedulerConfigRequest;
function CreateGiveawaySchedulerConfigRequestFromJSON(json) {
    return CreateGiveawaySchedulerConfigRequestFromJSONTyped(json, false);
}
exports.CreateGiveawaySchedulerConfigRequestFromJSON = CreateGiveawaySchedulerConfigRequestFromJSON;
function CreateGiveawaySchedulerConfigRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'repeatTimes': !(0, runtime_1.exists)(json, 'repeatTimes') ? undefined : json['repeatTimes'],
        'durationTime': json['durationTime'],
        'ownerId': json['ownerId'],
    };
}
exports.CreateGiveawaySchedulerConfigRequestFromJSONTyped = CreateGiveawaySchedulerConfigRequestFromJSONTyped;
function CreateGiveawaySchedulerConfigRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'repeatTimes': value.repeatTimes,
        'durationTime': value.durationTime,
        'ownerId': value.ownerId,
    };
}
exports.CreateGiveawaySchedulerConfigRequestToJSON = CreateGiveawaySchedulerConfigRequestToJSON;
